import React, { useState, useEffect } from 'react';
import Sparkle from './Sparkle';
import soundManager from '../utils/soundEffects';
import Guestbook from './Guestbook';
import FindMeWidget from './FindMeWidget';
import Windows98Player from './Windows98Player';

const RetroSidebar = ({ onNavigate }) => {
  const [guestbookOpen, setGuestbookOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const navItems = [
    { name: 'home', icon: '🏠' },
    { name: 'about', icon: '💜' },
    { name: 'work', icon: '💼' },
    { name: 'projects', icon: '🖥️' },
    { name: 'achievements', icon: '🏆' },
    { name: 'skills', icon: '💪' },
    { name: 'writings', icon: '📝' },
    { name: 'contact', icon: '✉️' }
  ];

  const handleNavClick = (section) => {
    soundManager.playClick();
    onNavigate(section);
  };

  return (
    <>
      <div className="sidebar p-4 space-y-4">
        {/* Navigation */}
        <div className="window">
          <div className="window-header text-xs">🧭navigation</div>
          <div className="window-body">
            <ul className="list-none space-y-1 text-sm">
              {navItems.map((item) => (
                <li key={item.name}>
                  <Sparkle onInteract={() => handleNavClick(item.name)}>
                    <button
                      onClick={() => handleNavClick(item.name)}
                      className="w-full text-left hover:bg-pink-100 px-2 py-1 transition-colors flex items-center gap-2"
                    >
                      <span className="text-pink-600">&gt;</span>
                      <span>{item.icon}</span>
                      <span>{item.name}</span>
                    </button>
                  </Sparkle>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* My Time */}
        <div className="window">
          <div className="window-header text-xs">🕐 my time</div>
          <div className="window-body">
            <div className="text-center">
              <div className="text-lg font-bold pixel-text" style={{ color: '#ff1493' }}>
                {currentTime.toLocaleTimeString('en-US', { 
                  hour: '2-digit', 
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                  timeZone: 'Asia/Kolkata'
                })} IST
              </div>
            </div>
          </div>
        </div>

        {/* Find Me */}
        <FindMeWidget />

        {/* Windows 98 Music Player */}
        <Windows98Player />

        {/* Guestbook */}
        <div className="window">
          <div className="window-header text-xs">sign my guestbook!</div>
          <div className="window-body text-center">
            <Sparkle onInteract={() => {
              soundManager.playClick();
              setGuestbookOpen(true);
            }}>
              <button className="retro-btn text-xs w-full">
                ✍️ Sign Here!
              </button>
            </Sparkle>
          </div>
        </div>
      </div>

      {/* Guestbook Modal with proper z-index */}
      <Guestbook isOpen={guestbookOpen} onClose={() => setGuestbookOpen(false)} />
    </>
  );
};

export default RetroSidebar;
